import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withI18n } from '@lingui/react';
import { t } from '@lingui/macro';
import '../../styles/core.scss';
import css from './reload.scss';
import Header from '../../components/header/header';
import Filter from '../filter/filter';
import Library from '../library/library';
import { getConfigValue, getParamByName } from '../../config';
import { getProductNameById } from '../../helpers/utils';
import { getLocale } from '../../helpers/locale';
import { ANALYTICS_EVENTS, trackEvent } from '../../analytics';

class Reload extends Component {
  static propTypes = {
    i18n: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.productId = getParamByName('productId') || -1;
    this.productName = '';
    this.pageStartedAt = null;
    this.timeOnPageTracked = false;
  }

  componentDidMount() {
    this.pageStartedAt = Date.now();
    window.addEventListener('beforeunload', this.trackTimeOnPage);

    trackEvent(ANALYTICS_EVENTS.pageView, {
      productId: this.productId
    });
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.trackTimeOnPage);
    this.trackTimeOnPage();
  }

  trackTimeOnPage = () => {
    if (this.timeOnPageTracked || !this.pageStartedAt) {
      return;
    }

    this.timeOnPageTracked = true;

    trackEvent(ANALYTICS_EVENTS.pageTimeOnPage, {
      productId: this.productId,
      durationSeconds: Math.round((Date.now() - this.pageStartedAt) / 1000)
    });
  };

  getHeaderText(i18n) {
    const locale = getLocale();

    if (locale.toLowerCase() === 'es-mx') {
      return `${i18n._(t`library`)} ${this.productName}`;
    }

    return `${this.productName} ${i18n._(t`library`)}`;
  }

  static getBackText(i18n) {
    const locale = getLocale();

    if (locale.toLowerCase() === 'es-mx') {
      return `${i18n._(t`Back`)}`;
    }

    return `${i18n._(t`Back`)}`;
  }

  render() {
    const { i18n } = this.props;
    const backUrl = getConfigValue('backUrl');

    this.productName = getProductNameById(Number(this.productId));
    return (
      <div className={css.component} >
        <div className={css.reloadform} >
          <Header text={this.getHeaderText(i18n)} btnTxt={Reload.getBackText(i18n)} backUrl={backUrl} />
          <Filter i18n={this.props} />
          <Library i18n={this.props} />
        </div>
      </div>
    );
  }
}

export default withI18n()(Reload);
